
import React from 'react';

const EmptyFollowingState = () => {
  return (
    <div className="py-4 text-center text-muted-foreground text-sm">
      <p>You haven't followed any journalists yet.</p>
      <p className="mt-2">Discover journalists in the 'Discover' tab.</p>
    </div>
  );
};

export default EmptyFollowingState;
